import { faCalendarDay, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import { ListCardHistoryBugDevopsController } from "../../../../../Controllers/DevOps/DevOpsController";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import {
    IdevOpsCardHistoryCRM,
    IGetBugCardDevOpsByIDCaso,
} from "../../../../../Interfaces/DevOps/DevOps";

interface IHistoricoCard {
    getBugCardDevOpsByIDCaso: IGetBugCardDevOpsByIDCaso | undefined;
}

export default function HistoricoCard(props: IHistoricoCard) {
    const { value: lstCardHistory, loading: lstCardHistoryLoading } =
        useAsyncEffect(() =>
            ListCardHistoryBugDevopsController(
                props.getBugCardDevOpsByIDCaso?.devOpsCardCRMV2
                    .iD_DEVOPS_CARD ?? 0
            )
        );

    //Tabela
    const formatter = (cell: any, row: IdevOpsCardHistoryCRM) => {
        console.log(row, "row");
        return (
            <div className="d-flex align-itens-center flex-column py-3 px-2">
                <header className="d-flex align-itens-center justify-content-between flex-wrap">
                    <div>
                        <FontAwesomeIcon
                            icon={faCalendarDay}
                            className="mr-2"
                        />
                        {moment(row.dT_ALTERACAO.toString()).format("lll")}
                    </div>
                    <div className="flags">
                        <div>
                            <span className="label abel-pill label-inline label-success">
                                <FontAwesomeIcon
                                    icon={faUser}
                                    className="mr-2"
                                />{" "}
                                Usuário: {row.dS_USUARIO_ALTERACAO}
                            </span>
                        </div>
                    </div>
                </header>
                <div
                    className="ds-historico"
                    dangerouslySetInnerHTML={{
                        __html: row.dS_HISTORICO_ALTERACAO,
                    }}
                />
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "iD_DEVOPS_CARD_HISTORICO",
            text: "Histórico",
            formatter,
        },
    ];

    return (
        <Table
            columns={columns}
            data={lstCardHistory?.devOpsCardHistoryCRM ?? []}
            keyField="iD_DEVOPS_CARD_HISTORICO"
            loading={lstCardHistoryLoading}
        />
    );
}
